enum LessonPlannerTranslationVariant {
                title = 'title' 
,lessonPlan = 'lessonPlan' 
,viewAssignments = 'viewAssignments' 
,assignLesson = 'assignLesson' 
,editAssignments = 'editAssignments' 
,editAssignment = 'editAssignment' 
,moveLessonTo = 'moveLessonTo' 
,bumpLessonTo = 'bumpLessonTo' 
,removeLesson = 'removeLesson' 
,previousWeek = 'previousWeek' 
,nextWeek = 'nextWeek' 
,assignmentTracker = 'assignmentTracker' 
,blankAssignment = 'blankAssignment' 
,manage = 'manage' 
,day = 'day' 
,week = 'week' 
,lessonPlanner = 'lessonPlanner' 
,assignments = 'assignments' 
,selectWorkbook = 'selectWorkbook' 
,selectClassroom = 'selectClassroom' 
,selectTeachingOrder = 'selectTeachingOrder' 
,notInUse = 'notInUse' 
,completed = 'completed' 
,currentlyInUse = 'currentlyInUse' 
,moveAndCombineLessonDescription = 'moveAndCombineLessonDescription' 
,moveAndSwapLessonDescription = 'moveAndSwapLessonDescription' 
,bumpLessonDescription = 'bumpLessonDescription' 
,bump = 'bump' 
,moveAndSwap = 'moveAndSwap' 
,moveAndCombine = 'moveAndCombine' 
,cancel = 'cancel' 
,back = 'back' 
,chooseHowToMoveLesson = 'chooseHowToMoveLesson' 
,viewAndManageTeachingOrderModalTitle = 'viewAndManageTeachingOrderModalTitle' 
,teachingOrderName = 'teachingOrderName' 
,actions = 'actions' 
,view = 'view' 
,preview = 'preview' 
,useThisOrder = 'useThisOrder' 
,delete = 'delete' 
,rename = 'rename' 
,close = 'close' 
,useThisTeachingOrder = 'useThisTeachingOrder' 
,renameTeachingOrder = 'renameTeachingOrder' 
,manageTeachingOrders = 'manageTeachingOrders' 
,manageTeachingOrder = 'manageTeachingOrder' 
,manageOptions = 'manageOptions' 
,customTeachingOrderCreated1 = 'customTeachingOrderCreated1' 
,customTeachingOrderCreated2 = 'customTeachingOrderCreated2' 
,teachingOrderChanged = 'teachingOrderChanged' 
,inActivePopOverChip = 'inActivePopOverChip' 
,activePopoverChip = 'activePopoverChip' 
,manageActiveChip = 'manageActiveChip' 
,manageInActiveChip = 'manageInActiveChip' 
,backToLessonPlanner = 'backToLessonPlanner' 
,startDateUpdatedSuccessfully = 'startDateUpdatedSuccessfully' 
,activeTeachingOrderChanged = 'activeTeachingOrderChanged' 
,teachingOrderNameChangedSuccessfully = 'teachingOrderNameChangedSuccessfully' 
,teachingOrderChangedSuccessfully = 'teachingOrderChangedSuccessfully' 
,yesDeleteTeachingOrder = 'yesDeleteTeachingOrder' 
,deleteTeachingOrderTitle = 'deleteTeachingOrderTitle' 
,addActivity = 'addActivity' 
,warningNoActivities = 'warningNoActivities' 
,durationNotification = 'durationNotification' 
,minutes = 'minutes' 
,cannotEditWarning1 = 'cannotEditWarning1' 
,cannotEditWarning2 = 'cannotEditWarning2' 
,editSchoolStartDate = 'editSchoolStartDate' 
,editSchoolStartDateDescription = 'editSchoolStartDateDescription' 
,saveChanges = 'saveChanges' 
,previousDay = 'previousDay' 
,nextDay = 'nextDay' 
,gotoToday = 'gotoToday' 
,unassign = 'unassign' 
,noLessonsPlannedForToday = 'noLessonsPlannedForToday' 
,noAssignmentsPlannedForToday = 'noAssignmentsPlannedForToday' 
,lessonsAndActivities = 'lessonsAndActivities' 
,duration = 'duration' 
,instructions = 'instructions' 
,edit = 'edit' 
,addNonTeachingDays = 'addNonTeachingDays' 
,nonTeachingDay = 'nonTeachingDay' 
,addNonTeachingDayToLessonPlan = 'addNonTeachingDayToLessonPlan' 
,schoolStartDate = 'schoolStartDate' 
,nonTeachingDays = 'nonTeachingDays' 
,teachingOrders = 'teachingOrders' 
,pleaseSelectNonTeachingDays = 'pleaseSelectNonTeachingDays' 
,teachersGuide = 'teachersGuide' 

            }
            
            export default LessonPlannerTranslationVariant;